import React, { useState, useEffect, useRef } from "react";
import "./styles/theme.scss";
import routes from "./routes/routes";
import { RecoilRoot } from "recoil";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useLocation } from "react-router-dom";
import NotFound from "./pages/notfound/NotFound";
import LoginPageLayout from "./components/layouts/LoginPageLayout";
import Toaster from "./components/toaster";
//import "bootstrap/dist/css/bootstrap.min.css";
import { ConfigProvider } from './context/ConfigContext';
import { ShopDetailsProvider } from './context/ShopDetailsContext';

const App = () => {
  const location = useLocation();

  //load the gtag script start
  useEffect(() => {
    if (!window.gtag) {
      let GA_MEASUREMENT_ID = "G-FMQ7XDJV93"; //staging
      if (window.location.hostname.includes('supercheckout.ai')){
        GA_MEASUREMENT_ID = "G-2DPMXDLVKQ"; //production & sandbox
      }

      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GA_MEASUREMENT_ID}', {
          page_path: window.location.pathname,
        });
      `;
      document.head.appendChild(script2);
    }
  }, []);
  //load the gtag script end

  //track GA page views on route change start
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname,
        page_title: document.title,
        referrer: document.referrer || 'direct'
      });
    }

    //code related to opening checkout inside iframe
    /* window.parent.postMessage(
      {
        type: "SUPERCHECKOUT_CURRENT_PAGE_LINK",
        page_url: window.location.href
      },
      "*"
    ); */
  }, [location]);
  //track GA page views on route change end

  //google analytics button event handling start
  useEffect(() => {
    const handleButtonClick = (event) => {
      const target = event.target.closest('button');

      if (target) {
        const buttonName = target.getAttribute('id') || target.getAttribute('name') || target.innerText || 'Unnamed Button';

        if (window.gtag) {
          window.gtag('event', 'click', {
            event_category: 'Button',
            event_label: buttonName,
            event_action: 'click',
            //page_location: window.location.href,
            page_path: window.location.pathname,
            page_title: document.title
          });
        }

        //console.log('Tracked button click:', buttonName);
      }
    };

    document.addEventListener('click', handleButtonClick);

    return () => {
      document.removeEventListener('click', handleButtonClick);
    };
  }, []);
  //google analytics button event handling end

  //check if it's PWA or not - start
  useEffect(() => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    if (isStandalone) {
      document.documentElement.classList.add('appMode___pwa');
    } else {
      document.documentElement.classList.add('appMode___browser');
    }
  }, []);
  //check if it's PWA or not - end

  return (
    <div className="d-flex flex-column">
      <Routes>
        {routes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <LoginPageLayout>{route.element}</LoginPageLayout>
              }
            />
          );
        })}

        {/* Add a fallback route for 404 without the Layout */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      <Toaster></Toaster>
    </div>
  );
};

const Root = () => {
  return (
    <ConfigProvider>
      <ShopDetailsProvider>
        <RecoilRoot>
          <Router basename="/">
            <App />
          </Router>
        </RecoilRoot>
      </ShopDetailsProvider>
    </ConfigProvider>
  );
};

export default Root;
